import { defineComponent as t, resolveComponent as r, openBlock as n, createBlock as p, normalizeProps as c, guardReactiveProps as s, withCtx as a, renderSlot as i, createElementVNode as d } from "vue";
import l from "../CdrIcon.vue.mjs";
import m from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const _ = t({
  name: "CaretRight",
  components: {
    CdrIcon: l
  },
  props: {
    props: {
      type: Object
    }
  }
}), f = /* @__PURE__ */ d("path", {
  role: "presentation",
  d: "M16 12a.997.997 0 00-.288-.702l-5.005-5.005a1 1 0 00-1.414 1.414L13.585 12 9.29 16.295a1 1 0 001.417 1.412l4.98-4.98A.997.997 0 0016 12z"
}, null, -1);
function u(o, h, C, $, g, R) {
  const e = r("cdr-icon");
  return n(), p(e, c(s(o.props)), {
    default: a(() => [i(o.$slots, "default"), f]),
    _: 3
  }, 16);
}
const z = /* @__PURE__ */ m(_, [["render", u]]);
export {
  z as default
};
